"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryButton = void 0;
var React = require("react");
var Animations_1 = require("../../Animations");
var Spinner_1 = require("../../Animations/Spinner");
var Icon_1 = require("../../Icons/Icon/Icon");
var Localization_1 = require("./../../Localization");
var PrimaryButton_styles_1 = require("./PrimaryButton.styles");
var PrimaryButton = /** @class */ (function (_super) {
    __extends(PrimaryButton, _super);
    function PrimaryButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialProgressIndicator = _this.props.ProgressIndicator ? _this.props.ProgressIndicator : "normal";
        _this.state = { ProcessFlow: _this.initialProgressIndicator };
        _this.componentWillUnmount = function () {
            window.clearTimeout(_this.timeOutId);
        };
        _this.handleClick = function (e) {
            // It's disabled, don't do anything, and let's click if it does something
            if (!_this.props.Disabled && _this.props.OnClick) {
                // Run the event. If we get something back here, it's a promise
                var clickResponse = _this.props.OnClick(e);
                // Don't want to be able to spam click it in the running state
                // Don't control the process flow state this way if we are doing it via props already
                if (_this.state.ProcessFlow !== "running" && clickResponse && !_this.props.ProgressIndicator) {
                    _this.setState({ ProcessFlow: "running" });
                    // Run the promise
                    clickResponse
                        .then(function () {
                        _this.setState({ ProcessFlow: "complete" }, function () {
                            window.clearTimeout(_this.timeOutId);
                            _this.timeOutId = window.setTimeout(function () { return _this.setState({ ProcessFlow: "normal" }); }, 5000);
                        });
                    })
                        .catch(function () {
                        // Let the implementation of the button handle displaying the error
                        _this.setState({ ProcessFlow: "normal" });
                    });
                }
            }
        };
        return _this;
    }
    PrimaryButton.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.ProgressIndicator) {
            return {
                ProcessFlow: nextProps.ProgressIndicator,
            };
        }
        else {
            return null;
        }
    };
    PrimaryButton.prototype.render = function () {
        return (React.createElement(PrimaryButton_styles_1.Button, { "aria-label": this.props.AriaLabel, disabled: this.props.Disabled, form: this.props.Form, ref: this.props.InnerRef, HasIcon: this.props.Icon !== undefined, ProcessFlow: this.state.ProcessFlow, onClick: this.handleClick, ShowAsEnabled: this.props.Theme ? this.props.Theme.ShowAsEnabled : true, type: this.props.Type, Width: this.props.FullWidth ? "100%" : "auto", IconPosition: this.props.IconPosition },
            React.createElement(PrimaryButton_styles_1.Caption, { ProcessFlow: this.state.ProcessFlow },
                this.props.Icon !== undefined &&
                    React.createElement(PrimaryButton_styles_1.IconContainer, { IconPosition: this.props.IconPosition },
                        React.createElement(Icon_1.Icon, { Height: "24px", Width: "24px", Icon: this.props.Icon })),
                this.props.Caption),
            this.state.ProcessFlow === "running" && (React.createElement(PrimaryButton_styles_1.RunningIndicator, { ProcessFlow: this.state.ProcessFlow },
                React.createElement(Spinner_1.Spinner, { Color: "white" }))),
            this.state.ProcessFlow === "complete" && (React.createElement(PrimaryButton_styles_1.ProcessCompleteIndicator, { ProcessFlow: this.state.ProcessFlow },
                React.createElement(Animations_1.AnimatedTick, { Size: "24px" }),
                this.props.CompletedCaption || Localization_1.strings.Label_Saved))));
    };
    PrimaryButton.defaultProps = {
        Type: "button",
    };
    return PrimaryButton;
}(React.Component));
exports.PrimaryButton = PrimaryButton;
